<span class="eyebrow" [class.eyebrow--light]="variant() === 'light'" [class.eyebrow--muted]="variant() === 'muted'">
  <ng-content></ng-content>
</span>
